import React from 'react';
import styled from '@emotion/styled';
import { Box } from '@mantine/core';

import { mediaQueryMobile } from '~/styles/mixins';

import CheckIcon from '~/assets/icons/check.svg';

import { ParagraphMedium } from '../typography';

const Flex = styled(Box)`
  display: flex;
`;

const List = styled(Box)`
  margin-top: 12px;
`;

const Item = styled(Flex)`
  margin: 12px 0;
  align-items: flex-start;
`;

const Icon = styled(Flex)`
  flex: 0 auto;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  background-color: #f4fbf8;
  color: #55c092;
  border-radius: 4px;
  > svg {
    width: 20px;
    height: 20px;
  }
  ${mediaQueryMobile} {
    width: 20px;
    height: 20px;
    border-radius: 2px;
    > svg {
      width: 16px;
      height: 16px;
    }
  }
`;

const Text = styled(ParagraphMedium)`
  flex: 1;
  margin-left: 10px;
  color: #434343;
`;

const ValuePointsList = ({ points }) => {
  return (
    <List>
      {points.map((point) => (
        <Item key={point}>
          <Icon>
            <CheckIcon />
          </Icon>
          <Text>{point}</Text>
        </Item>
      ))}
    </List>
  );
};

export default ValuePointsList;
